import dayjs from 'dayjs'

import { navigate } from '@redwoodjs/router'
const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss'

export function updateFiltersInUrl(filters) {
  const searchParams = new URLSearchParams(location.search)

  // Preserve non-filter URL parameters (like page, viewId, view)
  const preservedParams = {
    page: searchParams.get('page'),
    viewId: searchParams.get('viewId'),
    view: searchParams.get('view'),
  }

  if (filters?.searchText?.searchText) {
    searchParams.set('searchText', filters.searchText.searchText)
  } else {
    searchParams.delete('searchText')
  }

  for (const filterKey in filters) {
    const filter = filters[filterKey]
    if (filter.type === 'multi-select') {
      if (filter.selectedValues?.length > 0) {
        searchParams.set(filter.key, filter.selectedValues)
      } else {
        searchParams.delete(filter.key)
      }
    }

    if (filter.type === 'range') {
      if (filter.gte !== null && filter.gte !== undefined) {
        searchParams.set(`${filter.key}Gte`, filter.gte.toString())
      } else {
        searchParams.delete(`${filter.key}Gte`)
      }

      if (filter.lte !== null && filter.lte !== undefined) {
        searchParams.set(`${filter.key}Lte`, filter.lte.toString())
      } else {
        searchParams.delete(`${filter.key}Lte`)
      }
    }

    if (filter.type === 'date-range') {
      if (filter.gte) {
        searchParams.set(
          `${filter.key}Gte`,
          dayjs(filter.gte).format(DATE_FORMAT)
        )
      } else {
        searchParams.delete(`${filter.key}Gte`)
      }

      if (filter.lte) {
        searchParams.set(
          `${filter.key}Lte`,
          dayjs(filter.lte).format(DATE_FORMAT)
        )
      } else {
        searchParams.delete(`${filter.key}Lte`)
      }
    }

    if (filter.type === 'step-filter') {
      if (filter.selectedValues?.length > 0) {
        const queryParamValue = filter.selectedValues.map(
          ({ type, status, customStepId }) => {
            if (customStepId) {
              return status
                ? `CUSTOM:${customStepId}:${status}`
                : `CUSTOM:${customStepId}`
            }
            if (status) {
              return `${type}-${status}`
            }
            return type
          }
        )
        searchParams.set(filter.key, queryParamValue)
      } else {
        searchParams.delete(filter.key)
      }
    }
    if (filter.type === 'applicant-stage-filter') {
      if (filter.selectedValues?.length > 0) {
        const queryParamValue = filter.selectedValues.map((selectedValue) => {
          const { applicantStage } = selectedValue
          const subOption =
            selectedValue.hiringStage ||
            selectedValue.terminatedReason ||
            selectedValue.disqualifiedReason ||
            selectedValue.notInterestedReason
          if (subOption) {
            return `${applicantStage}-${subOption}`
          }
          return applicantStage
        })
        searchParams.set(filter.key, queryParamValue)
      } else {
        searchParams.delete(filter.key)
      }
    }

    if (filter.type === 'location') {
      if (filter?.values?.length > 0) {
        searchParams.set(filter.key, filter.values.join(','))
      } else {
        searchParams.delete(filter.key)
      }
    }
  }

  // Handle custom fields
  if (filters.customFields && filters.customFields.length > 0) {
    // Clear existing custom field params
    Array.from(searchParams.keys()).forEach((key) => {
      if (key.startsWith('cf_')) {
        searchParams.delete(key)
      }
    })

    // Add current custom field filters
    filters.customFields.forEach((cf) => {
      let value = ''
      if (cf.stringValue !== null && cf.stringValue !== undefined) {
        value = cf.stringValue
      } else if (cf.booleanValue !== null && cf.booleanValue !== undefined) {
        value = String(cf.booleanValue)
      } else if (cf.dateValue) {
        value = JSON.stringify({
          gte: cf.dateValue.gte ? dayjs(cf.dateValue.gte).format(DATE_FORMAT) : null,
          lte: cf.dateValue.lte ? dayjs(cf.dateValue.lte).format(DATE_FORMAT) : null,
        })
      } else if (cf.selectValues && cf.selectValues.length > 0) {
        // Use JSON encoding for arrays to handle option values containing commas
        // This prevents values like "Option A, B" from being incorrectly split
        value = JSON.stringify(cf.selectValues)
      }

      if (value) {
        searchParams.set(`cf_${cf.customFieldId}`, value)
      }
    })
  } else {
    // Clear all custom field params if no custom fields
    Array.from(searchParams.keys()).forEach((key) => {
      if (key.startsWith('cf_')) {
        searchParams.delete(key)
      }
    })
  }

  // Restore preserved parameters
  Object.entries(preservedParams).forEach(([key, value]) => {
    if (value) {
      searchParams.set(key, value)
    }
  })

  navigate(`?${searchParams.toString()}`, { replace: true })
}
